import script from "./notice-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./notice-info.vue?vue&type=script&lang=ts&setup=true"

import "./notice-info.vue?vue&type=style&index=0&id=6ce15c1e&lang=scss"

const __exports__ = script;

export default __exports__